<div class="tw-p-0 tw-w-[70vw]">
  <!-- title -->
  <app-modal-title [isShowClose]="true" (isCloseModal)="onClose()"></app-modal-title>

  <div mat-dialog-content class="dialog-content tw-bg-gray-50 dark:tw-bg-dark-600">
    <app-calendar-events [isModalMode]="true" [eventType]="eventType" (selectedCalendarEvent)="onSelectCalendarEvent($event)"
      (selectedCalenderOrganizationEvents)="onSelectCalenderOrganizationEvents($event)">
    </app-calendar-events>
  </div>

</div>